module.exports = __webpack_public_path__ + "unbind.e722236d2634c9623af4d451108f729c.hashedasset.svg";